import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Notifications } from '../../../components/notifications'
import {
  CurrentOrganization,
  isCurrentOrganization
} from '../../../components/current-organization'
import { CurrentUser, isCurrentUser } from '../../../components/current-user'
import { Predicates } from '../../components/validation'
import { ErrorBoundary } from '../../../legacy-design-system/error-boundary/error-boundary'

export interface NotificationBridgeProps {
  readonly currentOrganization: CurrentOrganization | undefined
  readonly currentUser: CurrentUser | undefined
  readonly isAuthenticated: boolean | undefined
}

export function NotificationsBridge({
  currentOrganization,
  currentUser,
  isAuthenticated
}: NotificationBridgeProps) {
  return showNotificationsMenu({
    currentOrganization,
    currentUser,
    isAuthenticated
  }) ? (
    <ErrorBoundary>
      <Notifications
        currentOrganization={currentOrganization as CurrentOrganization}
        currentUser={currentUser as CurrentUser}
        isAuthenticated={isAuthenticated as boolean}
      />
    </ErrorBoundary>
  ) : (
    <></>
  )
}

export const reactNotificationsMenu = createNgReactBridgeDirective(
  'reactNotificationsMenu',
  [],
  NotificationsBridge,
  ['currentOrganization', 'currentUser', 'isAuthenticated']
)

export const showNotificationsMenu = ({
  currentOrganization,
  currentUser,
  isAuthenticated
}: NotificationBridgeProps) => {
  return (
    isCurrentOrganization(currentOrganization) &&
    isCurrentUser(currentUser) &&
    Predicates.isBoolean(isAuthenticated) &&
    isAuthenticated
  )
}
